import styled from 'styled-components/macro';
import * as colors from 'components/common/colorConstants';

export const StyledNodesContainer = styled.div`
  width: 260px;
  position: absolute;
  top: calc(100% + 11px);
  right: -40px;
  z-index: 101;
  box-shadow: 0 4px 6px 0 rgba(198, 198, 198, 0.25);
  border: solid 0.8px ${colors.lightGray21};
  background-color: ${colors.baseBackground};
  border-radius: 4px;
`;

export const StyledPointer = styled.div`
  width: 25px;
  height: 25px;
  background: ${colors.baseBackground};
  position: absolute;
  transform: rotate(45deg);
  bottom: -32px;
  z-index: 10;
  border: solid 0.8px ${colors.lightGray21};
  box-shadow: -2px -2px 3px -2px rgba(198, 198, 198, 0.25);
  left: ${({ ratingScore }) => _getPointerPosition(ratingScore)};
  clip-path: polygon(0 0, 0 52%, 52% 0);
`;

const _getPointerPosition = (ratingScore) => {
  switch (ratingScore) {
    case 1:
      return '8%';
    case 5:
      return '50%';
    default:
      return '32%';
  }
};
